import {Lazily} from '@/components/refinedev/helpers';

/** Resources  */
import StaffList from '@/pages/resources/staffs/staff-list';
import StaffCreate from '@/pages/resources/staffs/staff-create';
import StaffEdit from '@/pages/resources/staffs/staff-edit';
import DepartmentCreate from '@/pages/resources/departments/department-create';
import DepartmentEdit from '@/pages/resources/departments/department-edit';
import DepartmentList from '@/pages/resources/departments/department-list';
import JobList from '@/pages/resources/jobs/job-list';
import JobCreate from '@/pages/resources/jobs/job-create';
import JobEdit from '@/pages/resources/jobs/job-edit';

import ImageList from '@/pages/resources/images/image-list';
import RoleList from '@/pages/resources/roles/role-list';
import RoleCreate from '@/pages/resources/roles/role-create';
import RoleEdit from '@/pages/resources/roles/role-edit';
import UserList from '@/pages/resources/users/user-list';
import UserCreate from '@/pages/resources/users/user-create';
import UserEdit from '@/pages/resources/users/user-edit';
import ActivityLogList from '@/pages/resources/activity-logs/list-page';
import ProjectList from '@/pages/resources/projects/project-list';
import ProjectCreate from '@/pages/resources/projects/project-create';
import ProjectEdit from '@/pages/resources/projects/project-edit';
import ProjectEditWorkflow from '@/pages/resources/projects/project-edit-workflow';
import TaskList from '@/pages/resources/tasks/task-list';
import TaskCreate from '@/pages/resources/tasks/task-create';
import TaskEdit from '@/pages/resources/tasks/task-edit';
import TaskShow from '@/pages/resources/tasks/task-show';
import ProjectShow from '@/pages/resources/projects/project-show';
import DocumentList from '@/pages/resources/documents/document-list';
import ProjectContractList from '@/pages/resources/project_contracts/project_contract-list';
import ProjectContractEdit from '@/pages/resources/project_contracts/project_contract-edit';
import ProjectContractCreate from '@/pages/resources/project_contracts/project_contract-create';
import ProjectContractShow from '@/pages/resources/project_contracts/project_contract-show';
import {Outlet, RouteObject} from 'react-router';
import {ResourceProps} from '@refinedev/core';
import {FC} from 'react';
import TaskEditWorkflow from '@/pages/resources/projects/task-edit-workflow';
import { UserShow } from '@/pages/resources/users/user-show';

export type ResourcePages = {
  listPage?: FC;
  createPage?: FC;
  editPage?: FC;
  showPage?: FC;
};

export function getResourceProps({
  name, // resource name
  pages, // resource pages (list, create, edit, show)
  label, // label for crumb
  meta, // meta for resource
  otherRoutes, // other routes
}: {
  name: string;
  pages: ResourcePages;
  label?: string;
  otherRoutes?: RouteObject[];
  meta?: Pick<ResourceProps, 'meta'>;
}): {route: RouteObject; resource: ResourceProps} {
  const {listPage, createPage, editPage, showPage} = pages;
  var children: RouteObject[] = otherRoutes || [];
  if (listPage)
    children.push({
      path: '',
      element: Lazily(listPage, {resource: name}),
      handle: {
        crumb: 'Danh sách',
      },
    });
  if (createPage)
    children.push({
      path: 'create',
      element: Lazily(createPage, {resource: name}),
      handle: {
        crumb: 'Tạo mới',
      },
    });
  if (editPage)
    children.push({
      path: ':id',
      element: Lazily(editPage, {resource: name}),
      handle: {
        crumb: ({id}) => `Chỉnh sửa #${id}`,
      },
    });
  if (showPage) {
    children.push({
      path: ':id/show',
      element: Lazily(showPage, {resource: name}),
      handle: {
        crumb: ({id}) => `Xem #${id}`,
      },
    });
  }

  var route: RouteObject = {
    path: name,
    element: <Outlet />,
    handle: {
      crumb: label || name,
    },
    children,
  };
  return {
    route,
    resource: {
      name,
      list: listPage ? `/${name}` : undefined,
      create: createPage ? `/${name}/create` : undefined,
      edit: editPage ? `/${name}/:id` : undefined,
      show: showPage ? `/${name}/:id/show` : undefined,
      meta,
    },
  };
}

//// resources
export const resources = [
  getResourceProps({
    name: 'staffs',
    pages: {
      listPage: StaffList,
      createPage: StaffCreate,
      editPage: StaffEdit,
    },
    label: 'Nhân viên',
  }),
  getResourceProps({
    name: 'departments',
    pages: {
      listPage: DepartmentList,
      createPage: DepartmentCreate,
      editPage: DepartmentEdit,
    },
    label: 'Phòng ban',
  }),
  getResourceProps({
    name: 'jobs',
    pages: {
      listPage: JobList,
      createPage: JobCreate,
      editPage: JobEdit,
    },
    label: 'Công việc',
  }),
  getResourceProps({
    name: 'images',
    pages: {
      listPage: ImageList,
    },
    label: 'Thư viện ảnh',
  }),
  getResourceProps({
    name: 'documents',
    pages: {
      listPage: DocumentList,
    },
    label: 'Tài liệu',
  }),
  getResourceProps({
    name: 'users',
    pages: {
      listPage: UserList,
      createPage: UserCreate,
      editPage: UserEdit,
      showPage: UserShow,
    },
    label: 'Tài khoản',
  }),
  getResourceProps({
    name: 'roles',
    pages: {
      listPage: RoleList,
      createPage: RoleCreate,
      editPage: RoleEdit,
    },
    label: 'Phân quyền',
  }),
  getResourceProps({
    name: 'projects',
    pages: {
      listPage: ProjectList,
      // createPage: ProjectCreate, //use dialog
      // editPage: ProjectEdit, //use dialog
      showPage: ProjectShow,
    },
    label: 'Dự án',
    otherRoutes: [
      // {
      //   path: ':id/conversations',
      //   element: Lazily(ProjectConversations),
      //   handle: {
      //     crumb: 'Cuộc trao đổi',
      //   },
      // },
      // {
      //   path: ':id/documents',
      //   element: Lazily(ProjectDocuments),
      //   handle: {
      //     crumb: 'Tài liệu dự án',
      //   },
      // },
      // {
      //   path: ':id/notes',
      //   element: Lazily(ProjectNotes),
      //   handle: {
      //     crumb: 'Ghi chú',
      //   },
      // },
      // {
      //   path: ':id/contracts',
      //   element: Lazily(ProjectContracts),
      //   handle: {
      //     crumb: 'Hợp đồng',
      //   },
      // },
      {
        path: ':id/editwf',
        element: Lazily(ProjectEditWorkflow),
        // handle: {
        //   crumb: 'Lưu đồ',
        // },
      },
      // {
      //   path: ':id/edit-tasks',
      //   element: Lazily(ProjectEditTasks),
      //   handle: {
      //     crumb: 'Công việc trong dự án',
      //   },
      // },
    ],
  }),
  getResourceProps({
    name: 'project_contracts',
    pages: {
      listPage: ProjectContractList,
      editPage: ProjectContractEdit,
      createPage: ProjectContractCreate,
      showPage: ProjectContractShow,
    },
    label: 'Hợp đồng',
  }),
  getResourceProps({
    name: 'tasks',
    pages: {
      listPage: TaskList,
      createPage: TaskCreate,
      editPage: TaskEdit,
      showPage: TaskShow,
    },
    label: 'Công việc',
    otherRoutes: [
      {
        path: ':id/editwf',
        element: Lazily(TaskEditWorkflow),
        handle: {
          crumb: 'Lưu đồ',
        },
      },
    ],
  }),
  getResourceProps({
    name: 'activity_logs',
    pages: {
      listPage: ActivityLogList,
    },
    label: 'Lịch sử hoạt động',
  }),
];
